<a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
    <span class="sr-only">Toggle navigation</span>
    <div class="icontoggle">
        <img [src]="imgArrowSrc" (mouseover)="onArrowMouseOver()" (mouseout)="onArrowMouseOut()" />
    </div>
</a>
